<template>
  <b-modal
    id="object-select-table"
    title="Hay multiples elementos con este numero. Elija uno para ver."
    hide-footer
    @show="handleShow"
    @hide="handleHide"
    centered
    body-class="p-0"
  >
    <b-spinner v-if="loading"></b-spinner>
    <b-table no-body :items="items" v-if="!loading" :fields="fields">
      <template v-slot:cell(accion)="data">
        <a href="#" @click.prevent="searchSelectedObject(data.item.id)"><i class="fa fa-lg fa-arrow-right"></i></a>
      </template>
    </b-table>
  </b-modal>
</template>

<script>
export default {
  name: "ObjectSelectTable",
  props: ["query"],
  data() {
    return {
      loading: false,
      items: []
    };
  },
  computed: {
    fields() {
      if (this.$route.params.topic === "pallet") {
        return ["number", "container", "origins", "varieties", "total_quantity", "accion"];
      } else {
        return ["number", "waybill_date", "company_name", "accion"];
      }
    }
  },
  methods: {
    searchSelectedObject(id) {
      this.$bvModal.hide("object-select-table");
      this.$emit("searchSelected", id);
    },
    handleShow() {
      let url = null;
      if (this.$route.params.topic === "waybill") {
        url = `/api/v1/waybill/received_waybills/?number=${this.query}&no_page=true`;
      }
      if (this.$route.params.topic === "pallet") {
        url = `/storage/pallet/?number=${this.query}&no_page=true`;
      }
      this.getList(url);
    },
    handleHide() {
      this.items = [];
      this.$emit("handleHide");
    },
    async getList(url) {
      const thisV = this;
      thisV.loading = true;
      try {
        const response = await thisV.$axios({
          method: "get",
          url: url
        });
        thisV.items = response.data;
        thisV.loading = false;
      } catch (error) {
        console.log(error);
        if (error.response.status_code != 500) {
          thisV.message = error.response.data.detail;
        } else {
          thisV.$toast.error("Error interno.", "");
        }
        thisV.loading = false;
      }
    }
  }
};
</script>

<style></style>
